export default function (val) {
  return  parseFloat(val).toLocaleString('en-US')
}
